import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import $t from '../../../../i18n'
import MaterialInput from '../../../common/MaterialInput'
import GiftingForm from '../Gifting/GiftingForm'
import MasterCardImg from '../../../../resources/MasterCard.svg'
import AmericanExpressImg from '../../../../resources/AmericanExpress.svg'
import DiscoverImg from '../../../../resources/Discover.svg'
import { Button, Radio } from 'antd'
import USCountries from '../../../../resources/us.json'
import { COUNTRY_CODES } from '../../../../consts'
import TextArea from 'antd/lib/input/TextArea'
import WalnutImage from '../../../../resources/Walnut.svg'
import { InfoCircleOutlined } from '@ant-design/icons'
import config from '../../../../config.json'
import Actions from '../../../../actions'
import VerificationIndicationIcon from '../../../common/VerificationIndicationIcon'
import VerificationCodeInput from '../../../common/VerificationCodeInput'
import MaterialSelectWithDropDown from '../../../common/MaterialSelectWithDropdown'
import DatePicker from '../../../common/DatePicker'

const PaymentPlanForm = ({
  errors,
  firstName,
  setFirstName,
  lastName,
  setLastName,
  email,
  setEmail,
  confirmEmail,
  setConfirmEmail,
  phoneNumber,
  setPhoneNumber,
  state,
  setState,
  dob,
  setDob,
  turnToolTip,
  setTurnToolTip,
  isPayNow,
  setIsPayNow,
  handleContinue,
  handleGiftingMVPContinue,
  setIsStateValid,
  sendVerificationCode,
  setPhoneCodeInput,
  enableButton,
  shouldValidate,
  giftRecipientFirstName,
  setGiftRecipientFirstName,
  giftRecipientLastName,
  setGiftRecipientLastName,
  giftRecipientEmail,
  setGiftRecipientEmail,
  giftRecipientConfirmEmail,
  setGiftRecipientConfirmEmail,
  giftRecipientPhoneNo,
  setGiftRecipientPhoneNo,
  customHeader,
}) => {
  // Redux States and Consts
  const dispatch = useDispatch()
  const stateList = USCountries
  const isGifting = useSelector(
    state => state?.payment?.selectedPlan?.[0]?.is_gifting
  )
  const isPPF = useSelector(state => state?.payment?.selectedPlan?.[0]?.is_ppf)
  const isLoadingCheckoutPage = useSelector(
    state => state?.payment?.isLoadingCheckoutPage
  )
  const validStates = useSelector(state => state.app?.validStates)
  const validSubscriptionStates = useSelector(
    state => state.app?.validSubscriptionStates
  )

  const selectedPlan = useSelector(state => state.payment?.selectedPlan?.[0])

  const ppfPhoneNumberErrorMessage = useSelector(
    state => state.payment.ppfPhoneNumberErrorMessage
  )
  const { isPPFUserAlreadyExist } = useSelector(state => state.payment)
  const phoneCodeIsSent = useSelector(state => state.payment.phoneCodeSent)
  const phoneIsValid = useSelector(state => state.payment.phoneIsValid)
  const phoneIsInvalid = useSelector(state => state.payment.phoneIsInvalid)

  // Functions

  const stateListNameValue = stateList.map(item => {
    return { label: item?.name, value: item?.name, isoCode: item?.isoCode }
  })

  const getVerifyTheCode = async verificationCode => {
    const ppfPhoneNumber = `+${phoneNumber.code}${phoneNumber.phone}`
    dispatch(
      Actions.createAction(Actions.PPF_PLAN_PHONE_VERIFY, {
        phoneNumber: ppfPhoneNumber,
        email,
        value: verificationCode,
        isPPFUserAlreadyExist,
      })
    )
    setPhoneCodeInput(false)
  }

  const onStateChange = (e, value) => {
    const stateCode = stateList?.find(
      state => state?.name?.toLowerCase() === value.label?.toLowerCase()
    )?.isoCode
    setState(value)
    if (selectedPlan?.show_terms) {
      setIsStateValid(validSubscriptionStates.includes(stateCode))
    } else {
      setIsStateValid(validStates.includes(stateCode))
    }
  }

  // UI Elements

  const renderSelectState = () => (
    <div className="state-select-conatiner">
      <div>
        {isGifting
          ? 'Where will the Gift Recipient use this service?'
          : ' Where will this service be used?'}
      </div>
      <div className="state-container">
        <MaterialSelectWithDropDown
          label="State"
          disabled={isLoadingCheckoutPage}
          value={state}
          onChange={onStateChange}
          data={stateListNameValue}
        />
        {errors?.state && <div className="state-error">{errors?.state}</div>}
      </div>
    </div>
  )
  const renderDOB = () => (
    <div className="form-element">
      <DatePicker
        setSelectedDate={setDob}
        label={$t('pages.getStarted.signupForm.dateOfBirth')}
      />
    </div>
  )

  const renderGiftRecipientMessage = () => (
    <div>
      <div className="form-heading gift-message-margin">
        Would you like to add a personal message to your gift recipient?
      </div>
      <div className="gifting-recipient-message-container">
        <TextArea showCount maxLength={500} rows={4} />
      </div>
    </div>
  )
  const renderWalnutInfo = () => (
    <div className="walnut-list-container">
      <div className="walnut-info-title">{$t('pages.walnutInfo.title')}</div>
      <ul>
        <li>{$t('pages.walnutInfo.line1')}</li>
        <li>
          {$t('pages.walnutInfo.line2')}
          <a
            href={config.walnutTermsURL}
            target="_blank"
            rel="noreferrer"
            className="signin-form-tandc"
          >
            {$t('pages.paymentplan.terms')}.
          </a>
        </li>
        <li>{$t('pages.walnutInfo.line3')}</li>
      </ul>
    </div>
  )

  const renderSelectBNPLPaymentMethod = () => (
    <div className="payment-radio-selector-container">
      <div>{$t('pages.paymentplan.form.payMentMethod')} </div>
      {errors?.isPayNow && (
        <div className="state-error">{errors?.isPayNow}</div>
      )}
      <div
        className={`radiobutton-container ${
          isPayNow === true && 'selected-radio'
        }`}
        onClick={() => (isLoadingCheckoutPage ? {} : setIsPayNow(true))}
      >
        <Radio checked={isPayNow}>
          <span htmlFor="credit-card" className="radio-button-label">
            {$t('pages.paymentplan.form.payWithCard')
              .replace(
                '{duration}',
                selectedPlan?.walnut_price?.duration +
                  ' ' +
                  selectedPlan?.walnut_price?.format
              )
              .replace('{price}', selectedPlan?.price)}
          </span>
        </Radio>

        <div className="payment-images">
          <img src={MasterCardImg} alt="" />
          <img src={AmericanExpressImg} alt="" />
          <img src={DiscoverImg} alt="" />
        </div>
      </div>

      <div
        className={`radiobutton-container ${
          isPayNow === false && 'selected-radio'
        }`}
        onClick={() => (isLoadingCheckoutPage ? {} : setIsPayNow(false))}
      >
        <Radio className="walnut-info" checked={!isPayNow}>
          <span htmlFor="interest-free" className="radio-button-label ">
            {$t('pages.paymentplan.form.payWithWalnut')
              .replace('{price}', selectedPlan?.walnut_price?.price)
              .replace('{duration}', selectedPlan?.walnut_price?.duration)
              .replace('{format}', selectedPlan?.walnut_price?.format)}
          </span>
        </Radio>
        <div className="payment-images">
          <img src={WalnutImage} className="walnut-img" alt="" />
        </div>
      </div>
      <div className="walnut-info-btn">
        <InfoCircleOutlined
          className="i-btn"
          onClick={() => setTurnToolTip(!turnToolTip)}
        />
        <div
          className={`walnut-info-container ${turnToolTip && 'show-tooltip'}`}
        >
          {renderWalnutInfo()}
        </div>
      </div>
    </div>
  )

  const renderVerificationCodeHelperText = () => {
    let helperText = $t(
      'pages.getStarted.signupForm.verificationCodeHelperText'
    )
    if (phoneIsValid) {
      return null
    }
    if (phoneIsInvalid) {
      helperText = $t('pages.getStarted.signupForm.invalidCode')
    }
    return (
      <div
        className={
          phoneIsInvalid
            ? 'verification-code-helpertext error-message'
            : 'verification-code-helpertext'
        }
      >
        <span>{helperText}</span>
        <br />
        {enableButton && (
          <>
            <span>{$t('pages.getStarted.signupForm.didntGetTheCode')}</span>
            <Button
              onClick={sendVerificationCode}
              className={
                phoneIsInvalid
                  ? 'verification-code-send-again-button error-message'
                  : 'verification-code-send-again-button'
              }
            >
              {$t('pages.getStarted.signupForm.sendAgain')}
            </Button>
          </>
        )}
      </div>
    )
  }
  const renderVerificationCodeHelperTextTop = () => {
    let helperText = $t(
      'pages.getStarted.signupForm.verificationCodeHelperTextTop'
    )

    return (
      <div className="verification-code-helpertext-top">
        <span>{helperText}</span>
      </div>
    )
  }
  const renderOneTimeCodeInput = () => (
    <div className="one-time-ppf-phone-code">
      <div className="verification-code-container">
        <div
          className="verification-code-with-icons-container"
          hidden={phoneCodeIsSent ? false : true}
        >
          {renderVerificationCodeHelperTextTop()}
          <VerificationIndicationIcon
            isVisible={phoneIsValid || phoneIsInvalid}
            isValid={phoneIsValid}
          />
          <VerificationCodeInput fields={6} onComplete={getVerifyTheCode} />

          {renderVerificationCodeHelperText()}
        </div>
      </div>
    </div>
  )

  return (
    <div className="payment-plan-form-container">
      <div className="form">
        {isGifting && (
          <GiftingForm
            errors={errors}
            giftRecipientFirstName={giftRecipientFirstName}
            setGiftRecipientFirstName={setGiftRecipientFirstName}
            giftRecipientLastName={giftRecipientLastName}
            setGiftRecipientLastName={setGiftRecipientLastName}
            giftRecipientEmail={giftRecipientEmail}
            setGiftRecipientEmail={setGiftRecipientEmail}
            giftRecipientConfirmEmail={giftRecipientConfirmEmail}
            setGiftRecipientConfirmEmail={setGiftRecipientConfirmEmail}
            giftRecipientPhoneNo={giftRecipientPhoneNo}
            setGiftRecipientPhoneNo={setGiftRecipientPhoneNo}
          />
        )}
        {isGifting && renderSelectState()}
        <div className="form-heading">
          {' '}
          {customHeader
            ? customHeader
            : $t('pages.paymentplan.form.fillInYourDetails')}
        </div>
        <div className="form-element">
          <MaterialInput
            className="name uppercase"
            disabled={isLoadingCheckoutPage}
            type="text"
            value={firstName}
            errorText={errors?.firstName}
            onChange={e => setFirstName(e.target.value)}
            label={$t('pages.paymentplan.firstName')}
          />
        </div>
        <div className="form-element">
          <MaterialInput
            className="name uppercase"
            disabled={isLoadingCheckoutPage}
            type="text"
            value={lastName}
            errorText={errors?.lastName}
            onChange={e => setLastName(e.target.value)}
            label={$t('pages.paymentplan.lastName')}
          />
        </div>
        <div className="form-element">
          <MaterialInput
            disabled={isLoadingCheckoutPage}
            className="email"
            type="email"
            value={email}
            errorText={errors?.email}
            onChange={e => setEmail(e.target.value)}
            label={$t('pages.getStarted.signinForm.email')}
          />
        </div>
        <div className="form-element">
          <div className="email-confirm-with-icons">
            <MaterialInput
              disabled={isLoadingCheckoutPage}
              className="confirm-email"
              type="email"
              value={confirmEmail}
              errorText={errors?.confirmEmail}
              onChange={e => setConfirmEmail(e.target.value)}
              label={$t('pages.paymentplan.confirmEmail')}
            />
            <VerificationIndicationIcon
              isVisible={shouldValidate}
              isValid={!errors?.confirmEmail}
            />
          </div>
        </div>
        <div className="form-element">
          <MaterialInput
            disabled={isLoadingCheckoutPage}
            countryCodes={COUNTRY_CODES}
            className="name"
            value={phoneNumber}
            errorText={errors?.phoneNumber}
            onChange={e => setPhoneNumber(e)}
            label={$t('pages.paymentplan.phoneNumber')}
            type="phone"
          />
        </div>
        {isPPF && !isGifting && renderDOB()}
        {!isGifting && renderSelectState()}
        {!isGifting && !isPPF && renderSelectBNPLPaymentMethod()}
        {isGifting && renderGiftRecipientMessage()}
        {isPPF && !isGifting && phoneCodeIsSent && renderOneTimeCodeInput()}
        {ppfPhoneNumberErrorMessage && (
          <p className="error-message phone-error-ppf">
            {ppfPhoneNumberErrorMessage}
          </p>
        )}
        {!isGifting && handleContinue()}
        {isGifting && handleGiftingMVPContinue()}
      </div>
    </div>
  )
}

export default PaymentPlanForm
